var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"12px","text-align":"center"}},[_c('span',{staticClass:"return-btn",on:{"click":_vm.handleBack}},[_vm._v(" "+_vm._s(_vm.$t('返回'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }